export enum Permissions {
  MAIN_ACCESS = 'main_access'
}
